import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9.346 5.353c.21 -.129 .428 -.246 .654 -.353a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3m-1 3h-13a4 4 0 0 0 2 -3v-3a6.996 6.996 0 0 1 1.273 -3.707","key":"svg-0"}],["path",{"d":"M9 17v1a3 3 0 0 0 6 0v-1","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconBellOff = createReactComponent('outline', 'bell-off', 'BellOff', __iconNode);

export default IconBellOff;